import data from "./posts.json";

export interface Post {
  slug: string;
  title: string;
  subtitle: string;
  /** Meta/OG description and JSON-LD only — not shown on the page. */
  description: string;
  category: string;
  thumbnail: string;
  thumbnailSrcSet: string;
  featuredImage: string;
  featuredImageSrcSet: string;
  date: string | null;
  bodyHtml: string;
}

export const posts: Post[] = data;

/** Filter tabs shown above the blog list; only categories that have posts. */
const categoryOrder = ["HR", "Communities", "Ventures"];
const usedCategories = [...new Set(posts.map((p) => p.category))];
export const blogCategories = [
  "All",
  ...categoryOrder.filter((c) => usedCategories.includes(c)),
  ...usedCategories.filter((c) => !categoryOrder.includes(c)),
];

export const findPost = (slug: string | undefined) => posts.find((p) => p.slug === slug);
